import { Trans, useTranslation } from 'react-i18next';
import { Modal } from '@/components/ui';
import type { DeactivateAccountVM } from './useDeactivateAccount';

/**
 * EAA-1820 (frame 86): title/copy/footer switch on the account's CURRENT
 * `enabled` — see `useDeactivateAccount` for why only the disable direction
 * demands typing the username to confirm.
 */
export function DeactivateAccountDialog({ vm }: { vm: DeactivateAccountVM }) {
    const { t } = useTranslation();
    const row = vm.target;
    const open = Boolean(row);
    const disabling = Boolean(row?.enabled);

    return (
        <Modal
            open={open}
            onCancel={vm.close}
            title={disabling ? t('console.accounts.deactivate.disableTitle') : t('console.accounts.deactivate.enableTitle')}
            footer={
                <>
                    <button type="button" className="portal-btn" onClick={vm.close} disabled={vm.busy}>
                        {t('common.cancel')}
                    </button>
                    {disabling ? (
                        <button
                            type="button"
                            className="portal-btn portal-btn-danger"
                            onClick={vm.submitDisable}
                            disabled={vm.busy || !vm.confirmMatches}
                        >
                            {vm.busy ? t('console.accounts.deactivate.disableBusy') : t('console.accounts.deactivate.disableButton')}
                        </button>
                    ) : (
                        <button type="button" className="portal-btn portal-btn-primary" onClick={vm.submitEnable} disabled={vm.busy}>
                            {vm.busy ? t('console.accounts.deactivate.enableBusy') : t('console.accounts.deactivate.enableButton')}
                        </button>
                    )}
                </>
            }
        >
            {disabling ? (
                <>
                    <div className="acc-deactivate-warning">
                        <strong>{t('console.accounts.deactivate.warnBold')}</strong>{' '}
                        {t('console.accounts.deactivate.warnBody')}
                    </div>
                    <p className="portal-admin-hint">{t('console.accounts.deactivate.disableHint')}</p>
                    <label className="sa-dialog-field">
                        <Trans
                            i18nKey="console.accounts.deactivate.confirmLabel"
                            values={{ username: row?.username }}
                            components={{ code: <code /> }}
                        />
                        <input
                            value={vm.confirmText}
                            onChange={(e) => vm.setConfirmText(e.target.value)}
                            placeholder={row?.username}
                            autoComplete="off"
                        />
                    </label>
                </>
            ) : (
                <p className="portal-admin-hint">
                    {t('console.accounts.deactivate.enableHint', { username: row?.username })}
                </p>
            )}
            {vm.error && <p className="portal-admin-error">{vm.error}</p>}
        </Modal>
    );
}

export default DeactivateAccountDialog;
